import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ParallaxProvider } from "react-scroll-parallax";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/themify-icons.css";
import "./css/animate.css";
import "./css/flaticon_medically.css";
import "./sass/style.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <ParallaxProvider>
      <App />
    </ParallaxProvider>
  </HelmetProvider>
);

reportWebVitals();
